import type { ContentPage } from "@/lib/content/types";

// CRM › CRM Analytics › Cohorts (leaf).
export const cohorts: ContentPage = {
  slug: "crm-analytics/cohorts",
  template: "hrmsFeature",
  seo: {
    title: "CRM Cohort Analysis - Segment & Track Customers | GetBiz CRM",
    description: "Run cohort analysis in GetBiz CRM to see how conversion, retention and revenue differ across customer segments and over time.",
    keywords: ["cohort analysis", "crm cohorts", "customer retention analysis", "sales cohort reporting"],
    ogImage: "/assets/data/seoimages/cohorts.webp",
  },
  leaf: {
    hero: {
      caption: "Cohorts",
      title: "Understand Groups of Customers Over Time",
      description: "Group leads and customers into cohorts to see how conversion, retention and value change across segments and time.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Cohorts",
      bullets: [
        { title: "Segment by Any Trait", description: "Group by source, industry, plan, signup date and more." },
        { title: "Retention View", description: "See how each cohort retains and converts over time." },
        { title: "Spot Best Segments", description: "Find which segments deliver the most value." },
        { title: "Guide Targeting", description: "Use insight to focus acquisition on the best-fit cohorts." },
      ],
      image: "/assets/images/img/product/crm/cohorts-lead-image.webp",
      imageAlt: "Cohorts — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of CRM Analytics",
      description: "Cohorts connects to every other part of CRM Analytics in GetBiz CRM.",
    },
    cards: [
      { title: "Reports", href: "/crm-software/crm-analytics/reports/", description: "Create, filter and schedule reports on leads, deals, activity and revenue.", image: "/assets/images/img/product/crm/reports.webp", imageAlt: "GetBiz CRM reports" },
      { title: "Charts", href: "/crm-software/crm-analytics/charts/", description: "Turn any report into clear bar, line, pie or funnel charts so trends and outliers jump out instantly.", image: "/assets/images/img/product/crm/charts.webp", imageAlt: "GetBiz CRM charts" },
      { title: "KPIs", href: "/crm-software/crm-analytics/kpis/", description: "Set targets and monitor sales KPIs.", image: "/assets/images/img/product/crm/kpis.webp", imageAlt: "GetBiz CRM kpis" },
      { title: "Funnels", href: "/crm-software/crm-analytics/funnels/", description: "Visualize your pipeline as a funnel to find the stages where deals stall, so you know precisely where to improve.", image: "/assets/images/img/product/crm/Funnels.webp", imageAlt: "GetBiz CRM funnels" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Cohorts in action.",
    relatedBlogs: "static",
    metaKey: "crm-analytics-cohorts",
  },
  sections: [],
};
